type Receipt = { value: string; label: string; mono?: boolean };

/* Engineering receipts — every card is a REAL, checkable product behavior
 * (verify it in the demo), not a testimonial. Founder call 2026-07-02:
 * no invented quotes/metrics; social proof returns when real quotes exist
 * (CONTENT_MAP G5). */
const RECEIPTS: Receipt[] = [
  { value: "§ on every check", label: "Each limit state names its clause: NDS-2024 3.3, 3.4, 3.10 print on the sheet" },
  { value: "167", label: "Catalog sections scored live, per limit state, when sizing a single member", mono: true },
  { value: "Deterministic", label: "The same plan and the same standards produce the same design, every run" },
  { value: "CD·CM·Ct·CF·Cr", label: "The full adjustment-factor ledger is printed on every calc; nothing is folded in silently", mono: true },
  { value: "Append-only", label: "Every action logged — who, what, when — retained with the project and exportable" },
  { value: "PE holds the stamp", label: "Nothing ships without your licensed PE's review and seal. AI never stamps." },
];

export function Proof() {
  return (
    <section className="landing-wrap landing-section" id="proof">
      <div className="section-head">
        <h2 className="section-title">Claims you can check on the sheet.</h2>
        <p className="section-sub">
          We&apos;re in private beta, so no borrowed testimonials. Each card below is a product
          behavior: bring a floor plan to the demo and verify every one.
        </p>
      </div>

      <div className="receipt-grid">
        {RECEIPTS.map((r) => (
          <div className="receipt-card" key={r.label}>
            <div className={`receipt-value${r.mono ? " receipt-value--mono" : ""}`}>{r.value}</div>
            <div className="receipt-label">{r.label}</div>
          </div>
        ))}
      </div>

      <p className="proof-disclaimer">In private beta with early residential firms. Real, attributable quotes land here when our first firms ship with it.</p>
    </section>
  );
}
